var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2018_26344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 4.99935V2.49935C5.83333 2.27834 5.92113 2.06637 6.07741 1.91009C6.23369 1.75381 6.44565 1.66602 6.66667 1.66602H16.6667C16.8877 1.66602 17.0996 1.75381 17.2559 1.91009C17.4122 2.06637 17.5 2.27834 17.5 2.49935V14.166C17.5 14.387 17.4122 14.599 17.2559 14.7553C17.0996 14.9116 16.8877 14.9993 16.6667 14.9993H14.1667V17.4993C14.1667 17.9594 13.7917 18.3327 13.3275 18.3327H3.33917C3.22927 18.3333 3.12033 18.3123 3.0186 18.2707C2.91687 18.2291 2.82436 18.1679 2.74638 18.0904C2.6684 18.013 2.60649 17.9209 2.56421 17.8195C2.52193 17.718 2.50011 17.6092 2.5 17.4993L2.5025 5.83268C2.5025 5.37268 2.8775 4.99935 3.34167 4.99935H5.83333ZM4.16917 6.66602L4.16667 16.666H12.5V6.66602H4.16917ZM7.5 4.99935H14.1667V13.3327H15.8333V3.33268H7.5V4.99935Z",
    fill: "#4776E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2018_26344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.c8cdf2a29d37865b5c42b22b74b995c5.svg";
export { ForwardRef as ReactComponent };